import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import axios from "../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import isConsultant from "../services/isConsultant";
import { Select } from "antd";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ActiveAndInactiveCandidates = (props) => {
  const location = useLocation();

  const [defaultDate, setDefaultDate] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [trfList, setTrfList] = useState([]);
  const [formData, setFormData] = useState([]);
  const [trf, setTrf] = useState("");
  const [formId, setFormId] = useState("");
  const [load, setLoad] = useState(false);
  const [disabbled, setDisabbled] = useState(true);
  const flag = useRef(false);
  //   const disabledDate = (current) => {
  //     return moment().startOf('day');
  //   };

  // useEffect(() => {
  //   if (flag.current) {
  //     loadCSV();
  //   }
  //   flag.current = true;
  // }, [defaultDate, trf, formId]);

  const [current, setCurrent] = useState(1);

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  const id = localStorage.getItem("user.id");

  const loadCSV = async () => {
    await axios
      .get(
        `/candidates/DownloadCSVActiveInActive?FormId=${formId}&Search=&Position=&ProcessId=&Status=&StartDate=${
          defaultDate[0]
            ? defaultDate[0]?._i
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]?._i
            : moment(new Date()).format("YYYY-MM-DD")
        }&ScoreType=&InterviewType=&Source=&TRF=${trf}&Designation=&RequestType="Dump"&userId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`
          }
        }
      )
      .then((res) => {
        const result = res.data.candidates;
        const flattenArray = result?.map((ele) => {
          let flatObject = { ...ele };
          function flatten(obj, keyPrefix) {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === "object") {
                Object.assign(flatObject, obj[key]);
                delete flatObject[key];
              }
            });
          }
          flatten(ele, "");
          return flatObject;
        });
        return flattenArray;
      })
      .catch((err) => {
        console.log(err);
        throw err
      });
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setCurrent(1);
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD")
      ]);
    } else {
      setCurrent(1);
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");

      if (moment(endDate).isAfter(moment(startDate).add(60, "days"))) {
        swal({
          title: "You can not select data more than 60 days",
          icon: "error"
        });
      } else {
        setDefaultDate([startDate, endDate]);
        setDisabbled(false);
      }
    }
  };

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  const getTrf = () => {
    axios
      .get(`/trf?Department=&Location=&trfStatus=${true}&isTRFAssignable=`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`
        }
      })
      .then((res) => {
        console.log(res.data);
        setTrfList(res.data);
      });
  };

  const getForm = () => {
    axios
      .get("/formtemplate", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`
        }
      })
      .then((res) => {
        const data = res.data;
        setFormData(data);
      });
  };

  useEffect(() => {
    getForm();
    getTrf();
  }, []);

  //CSV DATA
  const exportType = "csv";
  let fileName = `ACTIVE_INACTIVE_CANDIDATE_HISTORY_${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;

  // const downloadCSV = async() => {
  //   if(defaultDate.length === 0){
  //     swal({
  //       title: "Please select date range",
  //       icon: "error",
  //     })
  //   }
  //   else{
  //     const flattenArray =await csvData?.map(ele => {
  //       let flatObject = {...ele};
  //       function flatten(obj, keyPrefix) {
  //         Object.keys(obj).forEach(key => {
  //           if (typeof obj[key] === 'object') {
  //             Object.assign(flatObject, obj[key]);
  //             delete flatObject[key];
  //           }
  //         });
  //       }
  //       flatten(ele, '');
  //       return flatObject;
  //     });
  //     const data = flattenArray;
  //   setCurrent(1);
  //   exportFromJSON({ data, fileName, exportType });
  //   }
  // };

  const downloadCSV = async () => {
    const flattenArray = (data) => {
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };

    try{
      setLoad(true)
      const csvData = await loadCSV()
      if(csvData.length === 0) {
        return message.error("No data found.",2)
      }
      const data = flattenArray(csvData);
      setCurrent(1);
      exportFromJSON({ data, fileName, exportType });
    }catch(err) {
      console.log(err)
      message.error("Something went wrong.",2)
    }finally{
      setLoad(false)
    }

  };

  const disabledDate = (current) => {
    // Disable future dates
    return current && current > moment().endOf("day");
  };

  return (
    <Dashboard title="Active And Inactive Candidates">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Card>
        <div className="row ">
          <div className="col-md-6">
            <label htmlFor="candidate photo">Select Trf</label>
            <Select
              id="trf"
              showSearch
              style={{ width: "100%", height: "37px" }}
              placeholder="Select Trf"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0 ||
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
              onChange={(value) => setTrf(value)}>
              {trfList?.map((option) => (
                <Option value={option?._id}>{`${option?.title}-${
                  option?.department
                }-${option?.location}-${option?.processName}-${moment(
                  option?.tat
                )
                  .utc()
                  .format("YYYY-MM-DD")}${
                  option?.workModal ? `-${option.workModal}` : ""
                }`}</Option>
              ))}
            </Select>
          </div>
          <div className="col-md-6">
            <label htmlFor="candidate photo">Select Form</label>
            <Select
              id="process"
              showSearch
              style={{ width: "100%", height: "37px" }}
              placeholder="Select Form"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0 ||
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
              onChange={(value) => setFormId(value)}>
              {formData?.map(
                (form) =>
                  form?.formType !== "Document_Form" && (
                    <Option value={form?._id}>{form?.name}</Option>
                  )
              )}
            </Select>
          </div>
          <div className="col-md-6 mt-2">
            <label htmlFor="candidate photo">
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>
            <RangePicker
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              // defaultValue={[moment(), moment()]}
              onChange={handleDate}
              onOk={onOk}
              disabledDate={disabledDate}
              placeholder={[
                moment(new Date()).format("YYYY-MM-DD"),
                moment(new Date()).format("YYYY-MM-DD")
              ]}
            />
          </div>
          <div className="col-md-3 align-items-end d-flex">
            <button
              disabled={disabbled}
              className={`btn ${
                disabbled ? "btn-secondary" : "btn-primary"
              } btn-block`}
              onClick={downloadCSV}>
              Download CSV
            </button>
          </div>
        </div>
      </Card>
    </Dashboard>
  );
};

export default ActiveAndInactiveCandidates;
